<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3168_37273)">
      <path
        d="M17.5859 4.69727H15.8183C14.803 4.69727 13.9771 5.52324 13.9771 6.53849V17.5859C13.9771 18.6011 14.803 19.4271 15.8183 19.4271H17.5859C18.6011 19.4271 19.4271 18.6011 19.4271 17.5859V6.53849C19.4271 5.52324 18.6011 4.69727 17.5859 4.69727ZM17.9541 17.5859C17.9541 17.7889 17.7889 17.9541 17.5859 17.9541H15.8183C15.6152 17.9541 15.45 17.7889 15.45 17.5859V6.53849C15.45 6.33544 15.6152 6.17025 15.8183 6.17025H17.5859C17.7889 6.17025 17.9541 6.33544 17.9541 6.53849V17.5859Z"
        fill="#AABED4"
      />
      <path
        d="M4.18168 10.2946H2.4141C1.39885 10.2946 0.572876 11.1206 0.572876 12.1358V17.5859C0.572876 18.6011 1.39885 19.4271 2.4141 19.4271H4.18168C5.19693 19.4271 6.02291 18.6011 6.02291 17.5859V12.1358C6.02291 11.1206 5.19693 10.2946 4.18168 10.2946ZM4.54993 17.5859C4.54993 17.7889 4.38473 17.9541 4.18168 17.9541H2.4141C2.21105 17.9541 2.04586 17.7889 2.04586 17.5859V12.1358C2.04586 11.9328 2.21105 11.7676 2.4141 11.7676H4.18168C4.38473 11.7676 4.54993 11.9328 4.54993 12.1358V17.5859Z"
        fill="#AABED4"
      />
      <path
        d="M10.8838 0.572937H9.11625C8.101 0.572937 7.27502 1.39891 7.27502 2.41416V17.5859C7.27502 18.6011 8.101 19.4271 9.11625 19.4271H10.8838C11.8991 19.4271 12.7251 18.6011 12.7251 17.5859V2.41416C12.7251 1.39891 11.8991 0.572937 10.8838 0.572937ZM11.2521 17.5859C11.2521 17.7889 11.0869 17.9541 10.8838 17.9541H9.11625C8.9132 17.9541 8.74801 17.7889 8.74801 17.5859V2.41416C8.74801 2.21111 8.9132 2.04592 9.11625 2.04592H10.8838C11.0869 2.04592 11.2521 2.21111 11.2521 2.41416V17.5859Z"
        fill="#AABED4"
      />
    </g>
    <defs>
      <clipPath id="clip0_3168_37273">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
